module.exports = __webpack_public_path__ + "static/img/wang2.b8a6a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wang2.jpg
// module id = XB/y
// module chunks = 1